import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

import { buttonVariants, buttonWidths } from '@clatter/ui';
import { NgBuildIcon, NgButton, NgErrorMessage } from '../../../UI';

const StyledActionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small} 0;
`;

const StyledButtonContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  > span {
    max-width: 130px;
    text-align: center;
  }
`;

interface DocumentsGenerateButtonProps {
  disabled: boolean;
  onClick: () => void;
  errorMessage?: string | null;
  label: string | ReactNode;
  isLoading?: boolean;
  isDownloadReady?: boolean;
  loadingMessage?: string | null;
}

export const DocumentsGenerateButton: FC<DocumentsGenerateButtonProps> = ({
  disabled,
  onClick,
  errorMessage,
  label,
  isLoading = false,
  isDownloadReady = false,
  loadingMessage,
}) => {
  const buttonLabel = isDownloadReady ? (
    <StyledButtonContent>
      <CloudDownloadOutlinedIcon fontSize="small" />
      Download
    </StyledButtonContent>
  ) : (
    label
  );

  return (
    <StyledActionContainer>
      <NgButton
        variant={isDownloadReady ? buttonVariants.success : buttonVariants.primary}
        width={buttonWidths.full}
        isLoading={isLoading}
        loadingSlot={
          <StyledButtonContent>
            <NgBuildIcon show />
            <span>{loadingMessage ?? 'Generating…'}</span>
          </StyledButtonContent>
        }
        disabled={disabled}
        onClick={onClick}
      >
        {buttonLabel}
      </NgButton>

      <NgErrorMessage message={errorMessage} />
    </StyledActionContainer>
  );
};
